<template>
    <div class="navWrapper">
        <div id="nav">
            <div class="logoWrapper">
                <div class="logo"></div>
            </div>
<!--            <router-link to="/">Home</router-link> |-->
<!--            <router-link to="/about">About</router-link> |-->
<!--            <router-link to="/lorem">Lorem</router-link> |-->
<!--            <hr />-->
<!--            <router-link to="/login">Login</router-link> |-->
<!--            <router-link to="/dashboard">Dashboard</router-link> |-->
<!--            <router-link to="/reports">Reports</router-link> |-->
<!--            <router-link to="/totals">Totals</router-link> |-->
<!--            <router-link to="/machines">Machines</router-link> |-->
<!--            <router-link to="/buildings">Buildings</router-link> |-->
<!--            <router-link to="/users">Users</router-link> |-->
<!--            <router-link to="/asphalts">Asphalts</router-link> |-->
<!--            <Button icon="pi pi-power-off" @click="signOut" />-->
            <ConfirmDialog></ConfirmDialog>
        </div>
        <PanelMenu :model="items">
            <template #item="{ item, root, active, hasSubmenu, label, props }">
                <template v-if="root">
                    <a v-if="item.disabled"
                       class="p-panelmenu-header-link panel-nav-disabled"
                       v-tooltip.right="'Brak uprawnień. Poproś o dostęp'"
                       @click.prevent>
                        <span :class="item.icon" class="p-panelmenu-header-icon" />
                        <span class="p-panelmenu-header-label">{{ label }}</span>
                    </a>
                    <a v-else class="p-panelmenu-header-link">
                  <span v-if="hasSubmenu" class="p-panelmenu-submenu-icon"
                        :class="active ? 'pi pi-angle-down' : 'pi pi-angle-right'" />
                        <span :class="item.icon" class="p-panelmenu-header-icon" />
                        <span class="p-panelmenu-header-label">{{ label }}</span>
                    </a>
                </template>
                <a v-else v-bind="props.action">
                    <span :class="item.icon" class="p-panelmenu-item-icon" />
                    <span class="p-panelmenu-item-label">{{ label }}</span>
                </a>
            </template>
        </PanelMenu>
    </div>
</template>

<script>
import Button from 'primevue/button';
import PanelMenu from 'primevue/panelmenu';
import ConfirmDialog from 'primevue/confirmdialog'
import {getMenuItems} from "../api";

export default {
    name: 'Nav',
    components: {
        Button,
        ConfirmDialog,
        PanelMenu
    },
    data() {
        return {}
    },
    methods: {
        signOut: function (){
            this.$confirm.require({
                message: 'Czy chcesz się wylogować?',
                header: 'Wylogowanie',
                icon: 'pi pi-power-off',
                accept: () => {
                    this.$router.push('/login')
                },
                reject: () => {

                }
            });
        }
    },
    computed: {
        items() {
            return getMenuItems(this.$router);
        }
    },
}
</script>

<style lang="scss">
@import "@core/scss";

div.navWrapper{
    @media print{
        display:none;
    }

    #nav {
        padding: 30px;
        background: #42454f;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }

        & > div.logoWrapper{
            & > div.logo{
                background-image: url(../assets/logo_white_100_25.svg);
                background-repeat: no-repeat;
                width: 100px;
                height: 25px;
                margin: auto;
            }
        }
    }
}

@include respond-to(768plus){
    a.p-panelmenu-header-link{
        background-color: $color-zodiac !important;
        color: $color-white !important;
        border-radius: 0 !important;
    }

    a.p-panelmenu-header-link.panel-nav-disabled,
    a.p-panelmenu-header-link.panel-nav-disabled * {
        pointer-events: auto;
        cursor: not-allowed;
    }

    a.p-panelmenu-header-action {
        color: $color-white !important;
    }

    div.p-panelmenu-content,
    div.p-panelmenu-header-content {
        background-color: $color-zodiac !important;
    }

    li.p-menuitem {
        &.p-focus {
            & > div.p-menuitem-content {
                background-color: $color-zodiac !important;
            }
        }
    }

    a.p-menuitem-link{
        margin-left: 20px !important;
        background-color: $color-zodiac !important;
        color: $color-white !important;

        & > span.p-menuitem-icon,
        & > span.p-menuitem-text{
            color: $color-white !important;
        }

        &:hover{
            background-color: $color-orange !important;
        }
    }
}

</style>
